<template>
  <footer class="gs-footer">
    <div class="gs-footer-inner">
    <p class="gs-copyright">© 2026 Saul Verde.</p>
    <nav class="gs-social" aria-label="Social links">

      <a href="https://github.com/Greenvahn" class="gs-social-link" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><g fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z"/><path d="M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zM31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm4.943.361c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0"/></g></svg>
      </a>

      <a href="https://www.linkedin.com/in/saul-verde-martinez/" class="gs-social-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path fill="currentColor" d="M116 3H12a8.91 8.91 0 00-9 8.8v104.42a8.91 8.91 0 009 8.78h104a8.93 8.93 0 009-8.81V11.77A8.93 8.93 0 00116 3zM39.17 107H21.06V48.73h18.11zm-9-66.21a10.5 10.5 0 1110.49-10.5 10.5 10.5 0 01-10.54 10.48zM107 107H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53V48.73h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75z"/></svg>
      </a>

      <a href="https://www.behance.net/saulverde" class="gs-social-link" aria-label="Behance" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><g fill="currentColor"><path d="M48.53 48.26c0-7.16-4.87-7.16-4.87-7.16h-20v15.35h18.76c3.24 0 6.11-1.04 6.11-8.19zM43.66 67.06h-20v18.38h19.1c2.87-.08 8.18-1 8.18-8.94-.03-9.5-7.28-9.44-7.28-9.44zM94.93 56.45c-10.63 0-12.11 10.6-12.11 10.6h22.6s.14-10.6-10.49-10.6z"/><path d="M111.25 2.16h-94.5A14.59 14.59 0 002.16 16.75v94.49a14.59 14.59 0 0014.59 14.59h94.49a14.59 14.59 0 0014.59-14.59V16.75a14.59 14.59 0 00-14.58-14.59zM79.86 32.92h28.38v8.48H79.86zM65.51 77.36c0 21-21.85 20.31-21.85 20.31H7.86v-68.8h35.8c10.88 0 19.47 6 19.47 18.32s-10.5 13.09-10.5 13.09c13.84 0 12.88 17.08 12.88 17.08zm53.09-1.12H83c0 12.78 12.11 12 12.11 12 11.43 0 11-7.4 11-7.4h12.09c0 19.64-23.54 18.29-23.54 18.29-28.25 0-26.43-26.3-26.43-26.3s0-26.43 26.43-26.43c27.85-.02 23.95 29.84 23.95 29.84z"/></g></svg>
      </a>

    </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;500&display=swap');

.gs-footer {
  font-family: var(--font-sans);
  background-color: var(--color-neutral-0);
  border-top: 1px solid var(--border-subtle);
}

.gs-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  max-width: 1200px;
  margin-inline: auto;
  padding: 1rem 1.5rem;
}

.gs-copyright {
  font-family: 'Roboto Mono', monospace;
  font-size: 11px;
  color: var(--text-tertiary);
  letter-spacing: 0.02em;
  margin: 0;
}

.gs-social {
  display: flex;
  align-items: center;
  gap: 16px;
}

.gs-social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-neutral-500);
  text-decoration: none;
  transition: color 0.15s;
}

.gs-social-link:hover {
  color: var(--color-neutral-800);
}

.gs-social-link svg {
  width: 18px;
  height: 18px;
}

.dark .gs-footer {
  background-color: #000000;
  border-top-width: 2px;
}

.dark .gs-social-link:hover {
  color: var(--color-neutral-200);
}

@media (min-width: 768px) {
  .gs-footer {
    padding-inline: 2rem;
  }
}
</style>
